import { useI18n } from "providers/I18n"

export const EmptyResponse = () => {
  const { t } = useI18n()
  return (
    <tr>
      <td style={{ padding: 30 }}>{t("revenue.no.data")}</td>
    </tr>
  )
}
